import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthMethod, ExclusiveMethodsArray } from '../../models/settings/auth-method';
import { EnabledAuthMethod } from '../../models/settings/enabled-auth-method';
import { SignSignatory } from '../../models/signrequest/sign.signatory';
import { Contact } from '../../models/contact/contact';
import { SignrequestUtils } from '@utils/signrequest-utils';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SortAuthMethodsPipe } from '../../pipes/sort-auth-methods/sort-auth-methods.pipe';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Signatory } from '@shared/models/document/signatory';
import {BaseAuthenticationMethod} from '@shared/models/signrequest/authentication/base-authentication-method';
import {AuthenticationMethod} from '@shared/models/document/authentication/authentication.method';

@Component({
    selector: 'app-auth-methods',
    templateUrl: './auth-methods.component.html',
    styleUrls: ['./auth-methods.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule, SortAuthMethodsPipe, NgbTooltipModule]
})
export class AuthMethodsComponent {
    @Input() signatory!: Partial<SignSignatory | Contact | Signatory>;
    @Input() enabled!: EnabledAuthMethod[];
    @Input() disabled: AuthMethod[] = [];
    @Input() previewMethod = false;
    @Input() exclusive?: AuthMethod;
    @Output() toggle: EventEmitter<AuthMethod> = new EventEmitter<AuthMethod>();

    exclusiveMethods = ExclusiveMethodsArray;

    toggleAuthMethod(method: EnabledAuthMethod) {
        this.toggle.emit(method.authenticationMethod);
    }

    isDisabled(enabledAuthMethod: EnabledAuthMethod): boolean {
        return this.disabled?.includes(enabledAuthMethod.authenticationMethod) ?? false;
    }



    hasAuthMethod(enabledAuthMethod: EnabledAuthMethod): boolean {
        if (!this.signatory || !this.signatory.authenticationMethods) {
            return false;
        }

        const methods = this.signatory.authenticationMethods;

        if (methods.length === 0) {
            return false;
        }

        if (typeof methods[0] === 'string') {
            return (methods as unknown as string[]).includes(enabledAuthMethod.authenticationMethod);
        }

        // Use duck typing (the 'in' operator) for interfaces or objects without prototypes
        if ('type' in methods[0] || methods[0] instanceof BaseAuthenticationMethod) {
            return (methods as any[]).some(am =>
                SignrequestUtils.findMethodByType(am, enabledAuthMethod.authenticationMethod, this.previewMethod)
            );
        }

        if ('authenticationMethods' in methods[0] && typeof methods[0].authenticationMethods === 'string') {
            return (methods as AuthenticationMethod[]).some(am => {
                let targetMethod = enabledAuthMethod.authenticationMethod.toLowerCase();
                const targetAuthType = this.previewMethod ? 'PREVIEW' : 'AFTERVIEW';

                if (this.previewMethod && targetMethod.endsWith('_preview')) {
                    targetMethod = targetMethod.split('_')[0];
                }

                if (targetMethod === 'document_anchors') {
                    targetMethod = 'documentanchor';
                }

                return am.authenticationMethods.toLowerCase() === targetMethod && am.authType === targetAuthType;
            });
        }

        return false;
    }
}
